import { isEmpty } from "lodash-es";
import { Form, InputGroup } from "react-bootstrap";
import styled from "styled-components";
import SubmitBtn from "../../form/SubmitBtn";

const ErrorText = styled.span`
  color: #fb4e4e;
  font-size: 14px;
  margin-top: 0.25rem;
  font-size: 0.8125rem;
  color: #fb4e4e;
`;

const TrackingFieldWithButton = ({
  label,
  classes,
  fieldRef,
  handleBlur,
  labelClassname,
  formGroupClasses,
  isRequired,
  noLabel,
  onButtonClick = () => {
    /**
     * @func event when button is clicked
     */
  },
  error,
  value,
  isTracking,
  ...props
}) => {
  return (
    <Form.Group
      id={`form-group-${props.name || props.id}`}
      className={formGroupClasses}
    >
      <Form.Label className={labelClassname}>{label}</Form.Label>
      <InputGroup className="input-group-merge surround-btn-slant appended">
        <Form.Control
          className={classes}
          ref={fieldRef || null}
          value={value}
          {...props}
        />
        <InputGroup.Append className="border-0">
          <SubmitBtn
            isSubmitting={isTracking}
            type="submit"
            className="btn-slant"
          >
            Track
          </SubmitBtn>
        </InputGroup.Append>
      </InputGroup>
      <ErrorText className="mt-2">{!isEmpty(error) && error}</ErrorText>
    </Form.Group>
  );
};

export default TrackingFieldWithButton;
